import styled from 'styled-components';

import { FormContextValues } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

const DESCRIPTION_FIELD_NAME = 'description';
const DEFAULT_MAX_LENGTH = 3600;

type MedicalInformationDescriptionFormBeanPart = {
   [DESCRIPTION_FIELD_NAME]: string | null;
};

type MedicalInformationDescriptionTextareaProps = Pick<
   FormContextValues<MedicalInformationDescriptionFormBeanPart>,
   'register' | 'control'
> & {
   readonly maxLength?: number;
   readonly required?: boolean;
};

const StyledTextarea = styled(Textarea)`
   height: initial;
`;

export const MedicalInformationDescriptionTextarea = (
   props: MedicalInformationDescriptionTextareaProps
): JSX.Element => {
   const { label, placeholder } = patientMedicalInformationTranslationKeys.shared.fields.descriptionTextarea;
   const mathLength = props.maxLength ?? DEFAULT_MAX_LENGTH;

   return (
      <StyledTextarea
         rows={2}
         maxRows={2}
         placeholder={placeholder}
         label={label}
         controller={props.register(DESCRIPTION_FIELD_NAME, { required: props.required })}
         maxLength={mathLength}
         testId={'description'}
         bottomRightElement={
            <Textarea.ModalView
               onChange={(value) => props.control.setValue(DESCRIPTION_FIELD_NAME, value)}
               initialValue={() => props.control.getValues(DESCRIPTION_FIELD_NAME) ?? ''}
               placeholder={placeholder}
               label={label}
               maxLength={mathLength}
            />
         }
      />
   );
};
